import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from "./FieldName.module.scss";

const FieldName = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'inviteFriend-form-companyName',
    defaultMessage: 'Name'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'name'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      customClassnames={{
        container: styles.container,
        input: styles.input
    }}
    />
  );
};

export default FieldName;
